import createReducer from 'app/redux/utils/create-reducer';

import { setStorage, storageKeys } from 'app/utils/localStorage';

import { initialState, Types } from './actions';

const clearSelectedAnswers = state => ({
  ...state,
  selectedAnswers: initialState.selectedAnswers,
});

const handleSelectAnswer = (state, action) => {
  const nextSelectAnswers = {
    ...state.selectedAnswers,
    ...action.payload,
  };

  setStorage(storageKeys.SELECTED_ANSWERS, nextSelectAnswers);

  return {
    ...state,
    selectedAnswers: nextSelectAnswers,
  };
};

const actionHandlers = {
  [Types.CLEAR_SELECTED_ANSWERS]: clearSelectedAnswers,
  [Types.SELECT_ANSWER]: handleSelectAnswer,
};

export default createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/redux/ui/questions/reducer.js